// ** Types
import React from 'react';

// ** UI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

// ** icons
import { SettingsSuggest } from '@mui/icons-material';

// ** Context
import { useHeaderOverride } from '@/context/HeaderOverrideContext';

const MaintenanceMode = ({ message }: { message?: string }) => {
	const { setOverride } = useHeaderOverride();

	React.useEffect(() => {
		setOverride({
			appBarVariant: 'light',
			showMenu: true
		});

		return () => setOverride(null);
	}, [setOverride]);

	return (
		<Container maxWidth="sm">
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					minHeight: '60vh',
					textAlign: 'center',
					gap: 3
				}}
			>
				<SettingsSuggest sx={{ fontSize: 80, color: 'text.secondary', opacity: 0.5 }} />

				<Typography variant="h4-normal" component="h1" sx={{ fontWeight: 'bold' }}>
					System-Wartung
				</Typography>

				<Typography variant="body-md" color="text.secondary">
					{message || 'Wir aktualisieren derzeit unsere Dienste. Bitte versuchen Sie es in ein paar Minuten erneut.'}
				</Typography>

				<Button variant="outlined" onClick={() => window.location.reload()} sx={{ mt: 2 }}>
					Seite aktualisieren
				</Button>
			</Box>
		</Container>
	);
};

export default MaintenanceMode;
